<template>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_23995_212119)">
            <path d="M18 12.2222V16.5556C18 16.9386 17.8478 17.306 17.5769 17.5769C17.306 17.8478 16.9386 18 16.5556 18H6.44444C6.06135 18 5.69395 17.8478 5.42307 17.5769C5.15218 17.306 5 16.9386 5 16.5556V6.44444C5 6.06135 5.15218 5.69395 5.42307 5.42307C5.69395 5.15218 6.06135 5 6.44444 5H10.7778" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M18 12.2222V16.5556C18 16.9386 17.8478 17.306 17.5769 17.5769C17.306 17.8478 16.9386 18 16.5556 18H6.44444C6.06135 18 5.69395 17.8478 5.42307 17.5769C5.15218 17.306 5 16.9386 5 16.5556V6.44444C5 6.06135 5.15218 5.69395 5.42307 5.42307C5.69395 5.15218 6.06135 5 6.44444 5H10.7778" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M18 5L12 12" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M18 5L12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M14 5H18V9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M14 5H18V9" stroke="currentColor"  stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M19.8848 22.5805L2.57275 1.19606" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M19.8848 22.5805L2.57275 1.19606" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </g>
        <defs>
            <clipPath id="clip0_23995_212119">
                <rect width="24" height="24" fill="white"/>
            </clipPath>
        </defs>
    </svg>
</template>

<script>
export default {
    name: "ExternalOff"
};
</script>
